import * as React from 'react';
const StomatiteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-2{fill:none;stroke:${secondaryColor ||
        '#ffcf38'};stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <circle cx={100} cy={115.58} r={8.66} className="prefix__cls-2" />
    <circle cx={100} cy={115.58} r={1.24} className="prefix__cls-2" />
    <circle cx={100} cy={115.58} r={16.14} className="prefix__cls-2" />
    <path
      d="M124.71 64.44c-6.53-6.78-15.31-10.52-24.71-10.52s-18.18 3.74-24.71 10.52c-9.61 9.99-14.53 23.02-14.62 38.74v.08c.92 20.38 11.03 31.24 19.35 36.77a35.95 35.95 0 0 0 19.97 6.05h.01c7.12 0 14.03-2.09 19.98-6.05 8.32-5.52 18.43-16.39 19.35-36.77v-.08c-.09-15.72-5.01-28.76-14.62-38.74m-6.57 72.82a32.68 32.68 0 0 1-36.28 0c-10.74-7.13-16.71-18.03-17.76-32.41h4.02c.76 2.23 2.7 7.22 6.31 12.26.11.15.22.29.32.44.3.29.71.47 1.17.47.54 0 1.02-.25 1.32-.65.23-.28.36-.64.36-1.03 0-.48-.2-.91-.52-1.22-3.76-5.23-5.54-10.43-6.03-12 .51-2.28 3.26-12.74 11.79-21.18 2.31 1.85 8.12 5.62 17.16 5.62s14.85-3.77 17.16-5.62c8.53 8.44 11.27 18.9 11.79 21.18-.49 1.57-2.27 6.79-6.04 12.03a.5.5 0 0 0-.09.12c-.25.29-.4.66-.4 1.07 0 .38.12.72.34 1 .3.41.79.68 1.34.68.43 0 .83-.16 1.12-.44.15-.2.29-.39.43-.59 3.56-5 5.48-9.93 6.23-12.14h4.02c-1.05 14.38-7.02 25.28-17.76 32.41M85.35 79.67l.36-.3c8.28-6.67 20.3-6.67 28.58 0l.36.3c-2.12 1.56-7.14 4.56-14.65 4.56s-12.54-2.99-14.65-4.56m46.64 21.86c-.99-3.95-4.79-16.03-15.62-24.75-9.49-7.64-23.26-7.64-32.74 0C72.8 85.5 69 97.58 68.01 101.53h-3.98c.41-14.09 5-25.79 13.65-34.78 5.91-6.13 13.83-9.51 22.32-9.51s16.41 3.38 22.31 9.51c8.66 8.99 13.25 20.69 13.66 34.78z"
      style={{
        fill: primaryColor || '#282828',
      }}
    />
  </svg>
);
export default StomatiteIcon;
